import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';

const icons = {
  BusinessCenterIcon
};

const serviceprovider = {
  id: 'serviceprovider',
  type: 'group',
  children: [
    {
      id: 'serviceprovider',
      title: 'Service Provider',
      type: 'item',
      url: '/service-provider',
      icon: icons.BusinessCenterIcon,
    }
  ]
};

export default serviceprovider;
